import React from 'react';

const Attach = ({ 
  height = '48px', 
  width = '48px', 
  color = '#B3B3B3'
}) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <title>attachment</title>
    <g>
      <path d="M17.06543,45.69238c-3.87402,0-7.51465-1.50781-10.25294-4.24707 c-5.65331-5.65332-5.65331-14.85254,0-20.50586L22.36816,5.38281c1.9834-1.9834,4.62012-3.0752,7.4248-3.0752 s5.44141,1.0918,7.4248,3.0752c4.09375,4.09375,4.09375,10.75586,0,14.84961L23.0752,34.37402 c-1.22754,1.22754-2.85938,1.9043-4.5957,1.9043s-3.36914-0.67578-4.59668-1.9043c-2.53418-2.5332-2.53418-6.65723,0-9.19238 L25.9043,13.16113c0.58594-0.58594,1.53516-0.58594,2.12109,0s0.58594,1.53516,0,2.12109L16.00391,27.30273 c-1.36426,1.36523-1.36426,3.58594,0,4.9502c1.32129,1.32227,3.62793,1.32324,4.9502,0l14.14258-14.1416 c2.92383-2.9248,2.92383-7.68262,0-10.60742c-2.92383-2.92383-7.68359-2.92383-10.60742,0L8.93359,23.06055 c-2.17188,2.17188-3.36816,5.06055-3.36816,8.13184s1.19629,5.95996,3.36816,8.13184s5.05957,3.36816,8.13184,3.36816 c3.07129,0,5.95996-1.19629,8.13184-3.36816l17.67676-17.67773c0.58594-0.58594,1.53516-0.58594,2.12109,0 s0.58594,1.53516,0,2.12109L27.31836,41.44531C24.58008,44.18457,20.93848,45.69238,17.06543,45.69238z" fill={color}/>
    </g>
  </svg>
);

export default Attach;
